<template lang="pug">
  div.stripevue
    div.row.justify-content-center(v-show="save_status.is_saved", style="margin-top: 25px;")
      div.col-11.col-xl-9
        div.row.justify-content-center.stripe-area
          div.col
            div.row(style="padding-left: 20px;")
              div.col(style="text-align:left; padding:0px;")
                p 保存済みのカードで支払う
            div.row(style="padding-left: 20px;")
              div.col-12.col-sm-8(style="text-align:left; padding:0px;")
                span(style="font-family: 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; color:#32325d;")
                  font-awesome-icon(icon="credit-card", style="margin-right:8px;")
                  | XXXX-XXXX-XXXX-{{ save_status.last4 }}
              div.col-11.col-sm-3(style="text-align:right; padding:0px;")
                button.stripe-paybtn(type="button", @click="pay") 購入する
              
              div.col-12(style="text-align:left; padding:0px;")
                span.text-danger(v-show="fail") 決済できませんでした。
          div.col-3.d-none.d-lg-block
            img.float-right(src="../assets/img/powered_by_stripe.png")

    div.row.justify-content-center(style="margin-top: 25px;")
      div.col-11.col-xl-9
        div.row.justify-content-center.stripe-area
          div.col(style="text-align:left; padding-bottom:10px;")
            form
              label(for="card-element") {{ save_status.is_saved? '別の':'' }}クレジットカード または デビットカードで支払う
              div.form-row
                div.col-12.col-sm-10.col-md-8(style="padding: 10px 0px 0px 0px;")
                  card.stripe-card(:class="{ complete }",:stripe="$store.state.stripe_pk",:options="stripeOptions",@change="complete = $event.complete",id="card-element")
                  label(style="margin: 10px;")
                    input(type="checkbox", v-model="save_card")
                    span(style="cursor:pointer;") カード情報を保存する
                  span
                    | (
                    span(style="color:blue; cursor:pointer;", v-popover.bottom="{ name:'save-tips' }") 詳細
                    | )
                  popover(name="save-tips", :width="300")
                    | カード情報はStripe上に保存されます。
                    br
                    | GokakuEssayLibraryがカード番号などの情報を直接保持することはありません。
                div.col-12.col-md-2.col-lg-3(style="text-align:right; padding-top: 12px;")
                  button.stripe-paybtn(type="button" @click="payCard" :disabled="!complete") 購入する
              div.row(style="text-align:left; padding-left:20px;")
                span.text-danger(v-show="failCard") 決済できませんでした。
          div.col-3.d-none.d-lg-block
            img.float-right(src="../assets/img/powered_by_stripe.png")
</template>


<script>
// import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from "vue-stripe-elements-plus";

export default {
  name: "StripeVue",
  components: {
    Card
  },
  data() {
    return {
      complete: false,
      stripeOptions: {
        hidePostalCode: true,
        style: {
          base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "18px",
            "::placeholder": {
              color: "#aab7c4"
            }
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        }
      },
      save_status: {
        is_saved: false,
        last4: ""
      },
      save_card: false,
      fail: false,
      failCard: false,
    //   statusCard:0,
    };
  },
  created() {
     this.$axios.get("/api/savecard").then(response => {
      this.save_status = response.data;
    });
  },
  mounted() {},
  methods: {
    payCard(e) {
      this.failCard = false;
      let btn = e.target;
      btn.disabled = true;
      btn.innerHTML = '処理中<div class="loader-inner ball-pulse" style="display: inline-block; vertical-align: sub; padding-left:14px;"><div></div><div></div><div></div></div>';
      createToken().then(data => {
        if (data.error) {
          // Inform the customer that there was an error.
          this.failCard = true;
          btn.disabled = false;
          btn.innerHTML = '購入する';
        } else {
          // Send the token to your server.
          let payload = {
            token: data.token.id,
            cart: this.$store.state.listitems.cart,
            amount: this.$store.state.amount,
            save: this.save_card
          };
          console.log(payload);
            this.$axios.post("/api/processorder", payload)
            .then(response => {
              let statusCard = response.data.status;
              if (statusCard === 200) {
                  this.paid();
              } else {
                  this.failCard = true;
                  btn.disabled = false;
                  btn.innerHTML = "購入する";
              }
            })
            .catch((error) => {
              this.failCard = true;
              btn.disabled = false;
              btn.innerHTML = "購入する";
            });
        }
      });
    },
    pay(e) {
      let payload = {
        cart: this.$store.state.listitems.cart,
        amount: this.$store.state.amount
      };
      console.log(e);
      console.log(payload);
      this.fail = false;
      let btn = e.target;
      btn.disabled = true;
      btn.innerHTML =
        '処理中<div class="loader-inner ball-pulse" style="display: inline-block; vertical-align: sub; padding-left:14px;"><div></div><div></div><div></div></div>';
      this.$axios.post("/api/processorder", payload)
      .then(response => {
        let status = response.data.status;
        if (status === 200) {
          this.paid();
        } else {
          this.fail = true;
          btn.disabled = false;
          btn.innerHTML = "購入する";
        }
      })
      .catch((error) => {
        this.fail = true;
        btn.disabled = false;
        btn.innerHTML = "購入する";
      });
    },
    paid (){
        console.log("success");
        this.$store.commit("paySuccess");
        this.$router.push("/mypage");
    }
  }
};
</script>



<style scoped>
.stripevue {
  font-size: 14px;
}

.stripe-area {
  background-color: rgb(247, 250, 252);
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
}

.stripe-area div.col, .stripe-area div.col-3, .stripe-area div.col-9, .stripe-area div.col-12 {
  padding: 20px;
}

input[type="checkbox"] {
  position: relative;
  margin: 0 1rem 0 0;
  cursor: pointer;
}
input[type="checkbox"]:before {
  position: absolute;
  z-index: 1;
  top: 0.125rem;
  left: 0.1875rem;
  width: 0.75rem;
  height: 0.375rem;
  content: "";
  -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  -webkit-transform: rotate(-45deg) scale(0, 0);
  transform: rotate(-45deg) scale(0, 0);
  border: 2px solid green;
  border-top-style: none;
  border-right-style: none;
}
input[type="checkbox"]:checked:before {
  -webkit-transform: rotate(-45deg) scale(1, 1);
  transform: rotate(-45deg) scale(1, 1);
}
input[type="checkbox"]:after {
  position: absolute;
  left: 0;
  width: 1rem;
  height: 1rem;
  content: "";
  cursor: pointer;
  border: 2px solid #e0e0e0;
  background: #ffffff;
}

.stripe-paybtn[disabled] {
  background: #84849d;
}
.stripe-paybtn {
  border: none;
  border-radius: 4px;
  outline: none;
  text-decoration: none;
  color: #fff;
  background: #32325d;
  white-space: nowrap;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-decoration: none;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
  margin-left: 20px;
}

/* .stripe-card {
  width: 400px;
} */
/* .stripe-card.complete {
  border-color: green;
} */
</style>

<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--complete {
  border-color: green;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>